window.Page = {

    centerMarquee : document.querySelector('.old-marquee-center'),
    textMarquee   : document.querySelector('.old-marquee-text-content'),
    sidebar       : document.querySelector('.sidebar-inner'),
    openIcons     : document.querySelectorAll('.event-date-open'),
    openSection   : document.querySelector('.event-accessibility'),

    // Let's launch this thing
    liftoff : () => {
        Page.hideCenterMarqueeOnScroll()
        Page.activateAccessibilitySection()

        window.addEventListener('load' , () => {
            Page.setMarqueeScrollDistance()
        })
    },

    setMarqueeScrollDistance : () => {

        // If we don't have the marquee we don't need to do anything
        if (!Page.textMarquee) return;

        document.body.style.setProperty('--marquee-transform-distance' , `-${Page.textMarquee.getBoundingClientRect().width}px`);

    },

    // My new function block
    hideCenterMarqueeOnScroll : () => {

        // If we don't have the marquee we don't need to do anything
        if (!Page.centerMarquee) return;

        function fadeOutTheCenterMarquee () {
            Page.centerMarquee.classList.add('faded-out')
            window.removeEventListener('scroll' , fadeOutTheCenterMarquee);
        }

        window.addEventListener('scroll' , fadeOutTheCenterMarquee);

    },

    // Scroll and activate section on open click
    activateAccessibilitySection : () => {

        if (!Page.openIcons.length) return;

        Page.openIcons.forEach(openIcon => {
            openIcon.addEventListener('click' , (event) => {

                // Prevent the link from being followed
                event.preventDefault()

                Page.openSection.scrollIntoView(true)
                Page.openSection.setAttribute('open' , true);
            })
        })

        // Open the section on page load if the fragment is present
        window.addEventListener('load' , () => {
            if (window.location.hash == "#open") {
                Page.openSection.setAttribute('open' , true);
                Page.openSection.scrollIntoView(true);
            }
        })

    }
};

Page.liftoff()